import React from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';

// Components
import ExtComp from '../../../../components/external';

// Service
import { campusTitle, parseDate } from '../../../../services/jobParsingData';

// Styles
import s from './CommunicationDetailsSection.style';


const CommunicationDetailsSection = (props) => {
  const { t, job, triggerMessagesModal } = props;

  return (
    <s.CommunicationDetailsSection className="job-details">
      {/* ──── Job details ─────────────────────────────────────────────────────────────────────── */}
      <div className="column">
        <p className="column-title">{t('job')}</p>

        <div className="column-row">
          <div className="half-row">
            <p className="sub-title">{t('job_type')}</p>
            <p>{t('job_type_communicate')}</p>
          </div>
          <div className="half-row">
            <p className="sub-title">{t('job_states')}</p>
            <p>{job && job.status || t('no_data')}</p>
          </div>
        </div>

        <div className="column-row">
          <div className="half-row">
            <p className="sub-title">{t('job_created')}</p>
            <p>{parseDate(job && job.createdAt)}</p>
          </div>
          <div className="half-row">
            <p className="sub-title">{t('created_by')}</p>
            <p>{job && job.createdBy && job.createdBy.name || t('no_data')}</p>
          </div>
        </div>

        <div className="column-row">
          <p className="sub-title">{t('job_completion')}</p>
          <p>{parseDate(job && job.completedAt)}</p>
        </div>
      </div>

      {/* ──── Appointment ─────────────────────────────────────────────────────────────────────── */}
      <div className="column">
        <p className="column-title">{t('appointments')}</p>
        <div className="column-row small-margin-bottom">
          <div className="half-row">
            <p className="sub-title">{t('appointments_date')}</p>
            <p>{job && job.goalsDate ?
              moment(job.goalsDate).format('DD.MM.YYYY dddd')
              : t('no_data')}
            </p>
          </div>
          <div className="half-row">
            <p className="sub-title">{t('appointments_selected')}</p>
            <p>{job && job.countGoals || t('no_data')}</p>
          </div>
        </div>

        <div className="column-row small-margins">
          {job && job.practitioner ?
            <ExtComp.PractitionerBlock practitioner={job.practitioner} />
            : t('no_data')
          }
        </div>

        <div className="column-row small-margins">
          <ExtComp.CampusBlock title={campusTitle(job)} />
        </div>

      </div>

      {/* ──── Message ─────────────────────────────────────────────────────────────────────────── */}
      <div className="column">
        <p className="column-title">{t('job_details_message')}</p>

        <div className="column-row small-margins">
          <p className="sub-title">{t('job_details_message_type')}</p>
          <p>
            {job && job.smsSettings && job.smsSettings.isActive &&
              <span className="item-with-comma">{t('nj_mass_message_type_sms')}</span>
            }
            {job && job.pushSettings && job.pushSettings.isActive &&
              <span className="item-with-comma">{t('nj_mass_message_type_push')}</span>
            }
          </p>
        </div>

        <div className="messages-details-part">
          {job && job.smsSettings && job.smsSettings.isActive && job.smsSettings.message ?
            <div className="column-row small-margins">
              <p className="sub-title">{t('job_details_sms_message_text')}</p>
              <p className="message-description">{job.smsSettings.message}</p>
            </div>
            : null
          }

          {job && job.pushSettings && job.pushSettings.isActive ?
            <div className="column-row small-margins">
              <p className="sub-title">{t('nj_mass_message_push_title')}</p>
              <p className="message-description">{job.pushSettings.title || t('no_data')}</p>
              <p className="sub-title">{t('nj_mass_message_push_message')}</p>
              <p className="message-description">{job.pushSettings.message || t('no_data')}</p>
            </div>
            : null
          }
        </div>

        <div className="column-row small-margins">
          <button className="get-more-details-btn" onClick={triggerMessagesModal}>
            {t('job_details_learn_more')}
          </button>

        </div>

      </div>

    </s.CommunicationDetailsSection>
  );
};

export default translate()(CommunicationDetailsSection);
